import React from "react";
import { ElementContainer } from "../../containers/styledComponents";
import { DynamicRenderContent } from "./DynamicContentRender";
import { Filter } from "../../../types/PageFilterTypes";

export const InTableFilterList = ({
  option,
  handleSelectOption,
}: InTableFilterProps): JSX.Element => {
  return (
    <ElementContainer
      p={10}
      pt={2}
      onClick={(): void => handleSelectOption(option)}
    >
      {<DynamicRenderContent option={option} />}
    </ElementContainer>
  );
};

type InTableFilterProps = {
  option: Filter;
  handleSelectOption: (option: Filter) => void;
};
